import { Component, ViewChild } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RegistrationService } from '../../services/registration.service';
import { VariablesService } from '../../services/variables.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import * as _ from 'lodash';

@Component({
  templateUrl: './demographics.component.html'
})
export class DemographicsComponent {
  @ViewChild('demographicsForm') form;

  varTrack;
  varLOB;
  varFirstTime;
  varPreConference;
  varWelcomeReception;
  varFinalNightConcert;
  varMorningWorkout;
  varDonation;
  donationvalues;
  varDonationAmount;
  varDonationOther;
  isRegComplete;
  varDesignatedSpeaker;
  varSponsorPreConference;
  sponsordayvalues;
  timesattending;
  varBreakfast;
  varPastEventsAttend;
  varSupplierRole;
  varAffiliation;
  varAffiliationOther;
  affiliationlist;
  firstTime;
  firstTimeValue;
  whyAttend;
  whyAttendValue;
  bestFeatureChecked;
  varVeteran;
  veteranOther;
  yesno;
  veteranlist;
  varFirstresponder;
  firstresponderlist;
  varFirstresponderOther;
  varVeteranOther;
  varLPLAStockholder;
  varContribute;
  contributeResponses;
  varContribution;
  contributiondropdownlist;
  varInitials;
  stateNetwork;
  varAdaSeating;
  careerStageList;
  varCareerStage;
  challengeList;
  varChallenge;
  varChallengeOther;
  varTopicOne;
  varTopicOneOther;
  varTopicOneLevel;
  varTopicTwo;
  varTopicTwoOther;
  varTopicTwoLevel;
  varTopicThree;
  varTopicThreeOther;
  varTopicThreeLevel;
  topicsOfInterestList;
  topicListOne;
  topicListTwo;
  topicListThree;
  levelOfInfoList;
  varGoalOne;
  varGoalOneOther;
  varGoalTwo;
  varGoalTwoOther;
  varGoalThree;
  varGoalThreeOther;
  fullGoalList;
  goalListOne;
  goalListTwo;
  goalListThree;
  SMStext;
  SMSprovider;
  providervalues;
  SMSproviderother;
  ContactConsent;
  varpromotionalemail;
  isSubmitting: boolean;
  attendee: any;
  enrollment;

  emailFormArray: Array<any> = [];
  otherChecked: boolean;

  isFormCompleted=false;

  constructor(
    private navigationService: NavigationService,
    private registrationService: RegistrationService,
    private variablesService: VariablesService
  ) {
    this.enrollment = this.registrationService.getEnrollment({});
    this.attendee = this.registrationService.getAttendee({});

    this.varTrack = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varTrack.ID,
      {}
    );

    this.varLOB = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varLOB.ID,
      {}
    );

    this.varFirstTime = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varFirstTime.ID,
      {}
    );
    
    this.varSupplierRole = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varSupplierRole.ID,
      {}
    );    
    this.varPreConference = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varPreConference.ID,
      {}
    );

    this.varWelcomeReception = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varWelcomeReception.ID,
      {}
    );

    this.varFinalNightConcert = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varFinalNightConcert.ID,
      {}
    );

    this.varMorningWorkout = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varMorningWorkout.ID,
      {}
    );

    this.varDonation = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varDonation.ID,
      {}
    );

    this.donationvalues = variablesService.donationvalues;


    this.varDonationAmount = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varDonationAmount.ID,
      {}
    );

    this.varDonationOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varDonationOther.ID,
      {}
    );

    this.varDesignatedSpeaker = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varDesignatedSpeaker.ID,
      {}
    );

    this.varSponsorPreConference = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varSponsorPreConference.ID,
      {}
    );
    

    this.varBreakfast = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varBreakfast.ID,
      {}
    );
    this.varPastEventsAttend = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varPastEventsAttend.ID,
      {}
    );

    this.varAffiliation = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varAffiliation.ID,
      {}
    );
    this.varAffiliationOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varAffiliationOther.ID,
      {}
    );
    this.SMStext = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varSMSConsent.ID,
      {}
    );
    this.stateNetwork = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varStateNetwork.ID,
      {}
    );
    this.SMSprovider = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varCellProvider.ID,
      {}
    );
    this.SMSproviderother = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.SMSproviderother.ID,
      {}
    );
    if (this.SMSprovider.Value === 'ATT') {
      this.SMSprovider.Value = 'AT&T';
    }
    this.varVeteran = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varVeteran.ID,
      {}
    );
    this.veteranlist = _.cloneDeep(variablesService.veteranlist);
    
    this.varVeteranOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varVeteranOther.ID,
      {}
    );

    this.varFirstresponder = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varFirstresponder.ID,
      {}
    );
    this.firstresponderlist = _.cloneDeep(variablesService.firstresponderlist);
    
    this.varFirstresponderOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varFirstresponderOther.ID,
      {}
    );
    this.varLPLAStockholder = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varLPLAStockholder.ID,
      {}
    );

    this.varContribute = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varContribute.ID,
      {}
    );

    this.varContribution = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varContribution.ID,
      {}
    );

    this.varInitials = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varInitials.ID,
      {}
    );
    
    this.varpromotionalemail = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varpromotionalemail.ID,
      {}
    );

    this.varAdaSeating = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varAdaSeating.ID,
      {}
    );

    this.careerStageList = variablesService.careerStageList;
    this.varCareerStage = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varCareerStage.ID,
      {}
    );

    this.challengeList = variablesService.challengeList;
    this.varChallenge = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varChallenge.ID,
      {}
    );

    this.varChallengeOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varChallengeOther.ID,
      {}
    );

    this.varTopicOne = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varTopicOne.ID,
      {}
    );
    
    this.varTopicOneOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varTopicOneOther.ID,
      {}
    );
    
    this.varTopicOneLevel = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varTopicOneLevel.ID,
      {}
    );
    
    this.varTopicTwo = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varTopicTwo.ID,
      {}
    );
    
    this.varTopicTwoOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varTopicTwoOther.ID,
      {}
    );
    
    this.varTopicTwoLevel = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varTopicTwoLevel.ID,
      {}
    );
    
    this.varTopicThree = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varTopicThree.ID,
      {}
    );
    
    this.varTopicThreeOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varTopicThreeOther.ID,
      {}
    );
    
    this.varTopicThreeLevel = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varTopicThreeLevel.ID,
      {}
    );

    this.topicsOfInterestList = _.cloneDeep(variablesService.topicsOfInterestList);
    this.topicListOne = _.cloneDeep(variablesService.topicsOfInterestList);
    this.topicListTwo = _.cloneDeep(variablesService.topicsOfInterestList);
    this.topicListThree = _.cloneDeep(variablesService.topicsOfInterestList);
    this.levelOfInfoList = variablesService.levelOfInfoList;

    //Filters lists if a topic was chosen previously
    this.topicOneChanged();
    this.topicTwoChanged();
    this.topicThreeChanged();

    this.varGoalOne = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varGoalOne.ID,
      {}
    );
    
    this.varGoalOneOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varGoalOneOther.ID,
      {}
    );
    
    this.varGoalTwo = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varGoalTwo.ID,
      {}
    );
    
    this.varGoalTwoOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varGoalTwoOther.ID,
      {}
    );
    
    this.varGoalThree = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varGoalThree.ID,
      {}
    );
    
    this.varGoalThreeOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varGoalThreeOther.ID,
      {}
    );

    this.fullGoalList = _.cloneDeep(variablesService.goalList);
    this.goalListOne = _.cloneDeep(variablesService.goalList);
    this.goalListTwo = _.cloneDeep(variablesService.goalList);
    this.goalListThree = _.cloneDeep(variablesService.goalList);

    this.goalOneChanged();
    this.goalTwoChanged();
    this.goalThreeChanged();

    this.yesno = _.cloneDeep(variablesService.yesno);
    this.contributeResponses = [
        {display: "Yes", value: 'Yes'},
        {display: "I am already a PAC Member", value: 'PAC Member'},
        {display: "No", value: 'No'},
      ];

    this.providervalues = _.cloneDeep(variablesService.providervalues);
    this.contributiondropdownlist = _.cloneDeep(variablesService.contributiondropdownlist);

    if (this.varTrack.Value === 'Benefit Advisor' || this.varTrack.Value==='Non-Benefit Advisor' || this.varTrack.Value==='Home Office') {
      if (this.varContribution.Value) {
        if (this.varContribution.Value === "$250" || this.varContribution.Value === "$500" || this.varContribution.Value === "$1000" || this.varContribution.Value === "$2500"
        || this.varContribution.Value === "$5000") {
          this.enrollment.$mtccontributetemp = this.varContribution.Value;
        } else {
          this.enrollment.$mtccontributetemp = "Other";
        }
      } else {
        this.varContribution.Value = "250";
      }
    }

    if(this.varLOB.Value === 'IS') {
      this.affiliationlist = [
        {display: "Financial Institution - Advisor", value: 'Financial Institution - Advisor'},
        {display: "Financial Institution - Program Manager", value: 'Financial Institution - Program Manager'},
        {display: "Financial Institution - Program Manger & Advisor", value: 'Financial Institution - Program Manger and Advisor'},
        {display: "Financial Institution - Sales Manager", value: 'Financial Institution - Sales Manager'},
        {display: "Financial Institution - Executive Management", value: 'Financial Institution - Executive Management'},
        {display: "Other", value: 'Other'}

      ];
    }else {
      this.affiliationlist = [
        {display: "LPL RIA - Advisor", value: 'LPL RIA - Advisor'},
        {display: "LPL RIA - Linsco / Employee Advisor", value: 'LPL RIA - Linsco / Employee Advisor'},
        {display: "LPL RIA - Strategic Wealth Services", value: 'LPL RIA - Strategic Wealth Services'},
        {display: "LPL RIA - Field Management", value: 'LPL RIA - Field Management'},
        {display: "LPL RIA - Admin or Office Staff", value: 'LPL RIA - Admin or Office Staff'},
        {display: "LPL RIA - Management Team", value: 'LPL RIA - Management Team'},
        {display: "LPL RIA Enterprise - Advisor", value: 'LPL RIA - Advisor'},
        {display: "LPL RIA Enterprise - Management", value: 'LPL RIA - Management'},
        {display: "LPL RIA Enterprise - Owner / Management", value: 'LPL RIA - Owner / Management'},
        {display: "RIA Hybrid Enterprise - Advisor", value: 'RIA Hybrid Enterprise - Advisor'},
        {display: "RIA Hybrid Enterprise - Management", value: 'RIA Hybrid Enterprise - Management'},
        {display: "RIA Hybrid Enterprise - Owner / Management", value: 'RIA Hybrid Enterprise - Owner / Management'},
        {display: "RIA Hybrid - Advisor", value: 'RIA Hybrid - Advisor'},
        {display: "RIA Hybrid - Owner / Advisor", value: 'RIA Hybrid - Owner / Advisor'},
        {display: "RIA Hybrid - Admin or Office Staff", value: 'RIA Hybrid - Admin or Office Staff'},
        {display: "RIA Hybrid - Management Team", value: 'RIA Hybrid - Management Team'},
        {display: "RIA Only - Advisor", value: 'RIA Only - Advisor'},
        {display: "RIA Only - Owner / Advisor", value: 'RIA Only - Owner / Advisor'},
        {display: "RIA Hybrid - Admin or Office Staff", value: 'RIA Hybrid - Admin or Office Staff'},
        {display: "RIA Hybrid - Management Team", value: 'RIA Hybrid - Management Team'},
        {display: "RIA Hybrid - Strategic Wealth Services", value: 'RIA Hybrid - Strategic Wealth Services'},
        {display: "Other", value: 'Other'}
      ];    
    }

      this.timesattending = variablesService.timesattending;


  }

  topicOneChanged() {
    if (this.varTopicOne.Value !== 'Other' && this.varTopicOne.Value !== '' && this.varTopicOne.Value !== undefined) {
      if (this.varTopicThree.Value !== 'Other') {
        this.topicListTwo = this.topicsOfInterestList.filter((topic) => (topic != this.varTopicOne.Value && topic != this.varTopicThree.Value));
      }
      else{
        this.topicListTwo = this.topicsOfInterestList.filter((topic) => topic != this.varTopicOne.Value);
      }
      if (this.varTopicTwo.Value !== 'Other') {
        this.topicListThree = this.topicsOfInterestList.filter((topic) => (topic != this.varTopicOne.Value && topic != this.varTopicTwo.Value));
      }
      else {
        this.topicListThree = this.topicsOfInterestList.filter((topic) => topic != this.varTopicOne.Value);
      }
    }
  }

  topicTwoChanged() {
    if (this.varTopicTwo.Value !== 'Other' && this.varTopicTwo.Value !== '' && this.varTopicTwo.Value !== undefined) {
      if (this.varTopicThree.Value !== 'Other') {
        this.topicListOne = this.topicsOfInterestList.filter((topic) => (topic != this.varTopicTwo.Value && topic != this.varTopicThree.Value));
      }
      else{
        this.topicListOne = this.topicsOfInterestList.filter((topic) => topic != this.varTopicTwo.Value);
      }
      if (this.varTopicOne.Value !== 'Other') {
        this.topicListThree = this.topicsOfInterestList.filter((topic) => (topic != this.varTopicOne.Value && topic != this.varTopicTwo.Value));
      }
      else {
        this.topicListThree = this.topicsOfInterestList.filter((topic) => topic != this.varTopicTwo.Value);
      }
    }
  }

  topicThreeChanged() {
    if (this.varTopicThree.Value !== 'Other' && this.varTopicThree.Value !== '' && this.varTopicThree.Value !== undefined) {
      if (this.varTopicTwo.Value !== 'Other') {
        this.topicListOne = this.topicsOfInterestList.filter((topic) => (topic != this.varTopicTwo.Value && topic != this.varTopicThree.Value));
      }
      else{
        this.topicListOne = this.topicsOfInterestList.filter((topic) => topic != this.varTopicThree.Value);
      }
      if (this.varTopicOne.Value !== 'Other') {
        this.topicListTwo = this.topicsOfInterestList.filter((topic) => (topic != this.varTopicOne.Value && topic != this.varTopicThree.Value));
      }
      else {
        this.topicListTwo = this.topicsOfInterestList.filter((topic) => topic != this.varTopicThree.Value);
      }
    }
  }

  goalOneChanged() {
    if (this.varGoalOne.Value !== 'Other' && this.varGoalOne.Value !== '' && this.varGoalOne.Value !== undefined) {
      if(this.varGoalThree.Value !== 'Other'){
        this.goalListTwo = this.fullGoalList.filter((goal) => (goal != this.varGoalOne.Value && goal != this.varGoalThree.Value));
      }
      else {
        this.goalListTwo = this.fullGoalList.filter((goal) => goal != this.varGoalOne.Value);
      }
      if(this.varGoalTwo.Value !== 'Other'){
        this.goalListThree = this.fullGoalList.filter((goal) => (goal != this.varGoalOne.Value && goal != this.varGoalTwo.Value));
      }
      else {
        this.goalListThree = this.fullGoalList.filter((goal) => goal != this.varGoalOne.Value);
      }
    }
  }

  goalTwoChanged() {
    if (this.varGoalTwo.Value !== 'Other' && this.varGoalTwo.Value !== '' && this.varGoalTwo.Value !== undefined) {
      if(this.varGoalThree.Value !== 'Other'){
        this.goalListOne = this.fullGoalList.filter((goal) => (goal != this.varGoalTwo.Value && goal != this.varGoalThree.Value));
      }
      else {
        this.goalListOne = this.fullGoalList.filter((goal) => goal != this.varGoalTwo.Value);
      }
      if(this.varGoalOne.Value !== 'Other'){
        this.goalListThree = this.fullGoalList.filter((goal) => (goal != this.varGoalOne.Value && goal != this.varGoalTwo.Value));
      }
      else{
        this.goalListThree = this.fullGoalList.filter((goal) => goal != this.varGoalTwo.Value);
      }
    }
  }

  goalThreeChanged() {
    if (this.varGoalThree.Value !== 'Other' && this.varGoalThree.Value !== '' && this.varGoalThree.Value !== undefined) {
      if(this.varGoalTwo.Value !== 'Other'){
        this.goalListOne = this.fullGoalList.filter((goal) => (goal != this.varGoalTwo.Value && goal != this.varGoalThree.Value));
      }
      else {
        this.goalListOne = this.fullGoalList.filter((goal) => goal != this.varGoalThree.Value);
      }
      if(this.varGoalOne !== 'Other'){
        this.goalListTwo = this.fullGoalList.filter((goal) => (goal != this.varGoalOne.Value && goal != this.varGoalThree.Value));
      }
      else {
        this.goalListTwo = this.fullGoalList.filter((goal) => goal != this.varGoalThree.Value);
      }
    }
  }

  /**
   * @function back
   * @description Uses [navigation.service.back()] to go back to previous page.
   */
  back() {
    this.navigationService.back();
  }

  /**
   * @function forward
   * @description Checks if form is valid then uses [navigation.service.forward()] to go forward to next page.
   */
  forward(form) {
    this.isFormCompleted=true;
    if (this.varTrack.Value === 'Benefit Advisor'  || this.varTrack.Value==='Non-Benefit Advisor' || this.varTrack.Value==='Home Office') {
      if (this.enrollment.$mtccontributetemp && this.enrollment.$mtccontributetemp !== "Other") {
        this.varContribution.Value = this.enrollment.$mtccontributetemp;
      }
    }

    //Clear Other variables if switched away from Other
    if (this.varTopicOne.Value !== 'Other' && this.varTopicOneOther.Value !== '' && this.varTopicOneOther.Value !== undefined) {
      this.varTopicOneOther.Value = '';
    }
    if (this.varTopicTwo.Value !== 'Other' && this.varTopicTwoOther.Value !== '' && this.varTopicTwoOther.Value !== undefined) {
      this.varTopicTwoOther.Value = '';
    }
    if (this.varTopicThree.Value !== 'Other' && this.varTopicThreeOther.Value !== '' && this.varTopicThreeOther.Value !== undefined) {
      this.varTopicThreeOther.Value = '';
    }
    if (this.varGoalOne.Value !== 'Other' && this.varGoalOneOther.Value !== '' && this.varGoalOneOther.Value !== undefined) {
      this.varGoalOneOther.Value = '';
    }
    if (this.varGoalTwo.Value !== 'Other' && this.varGoalTwoOther.Value !== '' && this.varGoalTwoOther.Value !== undefined) {
      this.varGoalTwoOther.Value = '';
    }
    if (this.varGoalThree.Value !== 'Other' && this.varGoalThreeOther.Value !== '' && this.varGoalThreeOther.Value !== undefined) {
      this.varGoalThreeOther.Value = '';
    }


    if (this.varContribute.Value !== 'Yes') {
      this.varContribution.Value = "";
      this.varInitials.Value = "";
      this.enrollment.$mtccontributetemp = "";
    }

    if (this.SMStext.Value === 'No') {
      this.SMSprovider.Value = "";
      this.SMSproviderother = "";
    }
    if (this.SMSprovider.Value !== 'Other') {
      this.SMSproviderother = "";
    }

    if (this.varDonation.Value === "No") {
      this.varDonationAmount.Value = "";
      this.varDonationOther.Value = "";
    }

    if (this.varTrack.Value === 'Benefit Advisor' || this.varTrack.Value==='Non-Benefit Advisor'){
      if(this.attendee.$mtcOptOut) {
        this.varpromotionalemail.Value = "Opted out"
      } else {
        this.varpromotionalemail.Value = "Opted in"
      }
    }

    if (form.valid) {
    this.isSubmitting = true;
    this.navigationService.forward();
    }
  }
}

